export default {
      id: "google_play-usage",
      viewBox: "0 0 140 60",
      url: "../dist/images/" + "sprite.svg#google_play-usage",
      toString: function () {
        return this.url;
      }
    }